var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line bg-color-c8 mb-4",staticStyle:{"margin":"auto"},style:({width: _vm.open ? _vm.openWidth : _vm.closeWidth, transition: _vm.transitionTime + ' all'})})}
var staticRenderFns = []

export { render, staticRenderFns }